<template>
  <div>
    <div v-if="!isRejected">
      <v-chip :color="status.color" class="lighten-4" small>
        {{ status.text }}
      </v-chip>
    </div>
    <div v-if="isRejected">
      <v-chip :color="status.color" class="lighten-4" small>
        {{ status.text }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import { MapReportStatuses } from '@/models/MapReport'

const statusItems = {
  [MapReportStatuses.Waiting]: { text: '発行待ち', color: 'yellow' },
  [MapReportStatuses.Completed]: { text: '発行済', color: 'primary' },
  [MapReportStatuses.Rejected]: { text: '却下', color: 'red' },
}

export default {
  name: 'AdminMapReportListStatus',
  props: {
    mapReportStatus: {
      type: String,
      default: '',
    },
  },
  computed: {
    status() {
      return statusItems[this.mapReportStatus]
    },
    isRejected() {
      return this.mapReportStatus === MapReportStatuses.Rejected
    },
  },
}
</script>

<style scoped></style>
